import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router';

export const Breadcrumb = ({ navList }: any) => {
    let navigate = useNavigate();
    function handleClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, item: any) {
        event.preventDefault();
        if (item.path) {
            navigate(item.path)
        }
    }

    return (
        <Stack spacing={2}>
            <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
                sx={{
                    fontSize: '12px'
                }}
            >
                {navList.map((item: any, index: any) => {
                    return <div key={index}>
                        {index < (navList.length -1) ?
                            <Link underline="hover"  color="inherit" onClick={(e: any) => handleClick(e, item)}>
                                {item?.name}
                            </Link>
                            :
                            <Typography sx={{ fontSize: '12px' }} key="3" color="text.primary">
                                {item?.name}
                            </Typography>
                        }
                    </div>
                })}
            </Breadcrumbs>
        </Stack>
    );
}
